import RelationshipMetadata from "../../RelationshipMetadata";

class ETLGoogleConfigurationETLGoogleConfigurationDetailRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ETLGoogleConfigurationETLGoogleConfigurationDetail";
        this.parentEnterpriseComponent = "ETLGoogleConfiguration";
        this.childEnterpriseComponent = "ETLGoogleConfigurationDetail";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ETLGoogleConfigurationUSID";
    }
}

export default ETLGoogleConfigurationETLGoogleConfigurationDetailRelationshipMetadata;